import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16d488e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "status" }
const _hoisted_2 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_3 = ["data-dp-tooltip"]
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = ["data-dp-tooltip"]
const _hoisted_7 = { class: "small text-muted" }
const _hoisted_8 = { class: "fw-600" }
const _hoisted_9 = {
  key: 0,
  class: "homepage"
}
const _hoisted_10 = ["data-dp-tooltip"]
const _hoisted_11 = {
  key: 1,
  class: "type"
}
const _hoisted_12 = { class: "abstract" }
const _hoisted_13 = { class: "created text-nowrap" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "buttons" }
const _hoisted_16 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_17 = ["disabled", "data-dp-tooltip"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "content_copy", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1))
const _hoisted_21 = ["data-dp-tooltip"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1))
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_CpsOverviewItemAbstract = _resolveComponent("CpsOverviewItemAbstract")!
  const _component_BaseMoveButtons = _resolveComponent("BaseMoveButtons")!
  const _component_ButtonContentPagePreview = _resolveComponent("ButtonContentPagePreview")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("i", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (this.updateStatus(this.fullContentPage.id, this.contentPage.status_code === _ctx.StatusEnum.PUBLISHED ? _ctx.StatusEnum.NOT_PUBLISHED : _ctx.StatusEnum.PUBLISHED)), ["prevent"])),
          class: _normalizeClass(["mas mas-fill-1", [this.contentPage.status_code === _ctx.StatusEnum.PUBLISHED ? 'text-success' : 'text-danger', this.canUpdatePage ? 'cu-p' : '']]),
          "data-dp-tooltip": this.contentPage.status_code === _ctx.StatusEnum.PUBLISHED ? _ctx.$t('published') : _ctx.$t('notPublished')
        }, " circle ", 10, _hoisted_3)
      ])
    ]),
    _createElementVNode("td", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, [
        _createTextVNode(_toDisplayString(this.contentPage.name) + " ", 1),
        (this.isLinkedPage)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "mas mas-fill-1 ms-2 text-warning",
              "data-dp-tooltip": _ctx.$t('cms.pageIsLinkedFromLibrary')
            }, "dataset_linked", 8, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_7, [
        _createTextVNode("slug: "),
        _createElementVNode("span", _hoisted_8, _toDisplayString(this.contentPage.slug), 1)
      ])
    ]),
    (this.canChangeOnHomepage)
      ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
          _createElementVNode("i", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (this.updateIsPublishedOnHome(this.fullContentPage.id, !this.contentPage.is_published_on_home)), ["prevent"])),
            class: _normalizeClass(["mas mas-fill-1", [this.contentPage.is_published_on_home ? 'text-success' : 'text-light', this.canUpdatePage ? 'cu-p' : '']]),
            "data-dp-tooltip": this.contentPage.is_published_on_home ? _ctx.$t('cms.publishedOnHomepage') : _ctx.$t('cms.notPublishedOnHomepage')
          }, " home ", 10, _hoisted_10)
        ]))
      : _createCommentVNode("", true),
    (!this.isLibrary && this.canChangeType)
      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
          _createVNode(_component_dp_form, {
            as: "form",
            novalidate: ""
          }, {
            default: _withCtx(({ errors }) => [
              _createVNode(_component_InputSelect, {
                modelValue: this.pageType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.pageType) = $event)),
                name: "pageType",
                class: "mb-n3",
                selectText: _ctx.$t('selectText'),
                options: this.pageTypeEnums,
                disabled: this.isLinkedPage,
                errors: errors
              }, null, 8, ["modelValue", "selectText", "options", "disabled", "errors"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", _hoisted_12, [
      (this.fullContentPage.cp_abstract)
        ? (_openBlock(), _createBlock(_component_CpsOverviewItemAbstract, {
            key: 0,
            "cp-abstract": this.fullContentPage.cp_abstract
          }, null, 8, ["cp-abstract"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", _hoisted_13, [
      (this.fullContentPage.created)
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.formatDate(new Date(this.fullContentPage.created))), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        (this.canMove)
          ? (_openBlock(), _createBlock(_component_BaseMoveButtons, {
              key: 0,
              onTop: _cache[3] || (_cache[3] = ($event: any) => (_ctx.moveContentPage(this.fullContentPage.id, _ctx.MoveActionEnum.TOP))),
              onUp: _cache[4] || (_cache[4] = ($event: any) => (_ctx.moveContentPage(this.fullContentPage.id, _ctx.MoveActionEnum.UP))),
              onDown: _cache[5] || (_cache[5] = ($event: any) => (_ctx.moveContentPage(this.fullContentPage.id, _ctx.MoveActionEnum.DOWN))),
              onBottom: _cache[6] || (_cache[6] = ($event: any) => (_ctx.moveContentPage(this.fullContentPage.id, _ctx.MoveActionEnum.BOTTOM)))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('copy',this.fullContentPage.id))),
          class: "btn btn-icon btn-warning ms-2",
          disabled: this.isLinkedPage,
          "data-dp-tooltip": _ctx.$t('copy'),
          "data-dp-position": "left"
        }, _hoisted_19, 8, _hoisted_17),
        _createVNode(_component_ButtonContentPagePreview, {
          "page-id": this.fullContentPage.id,
          "data-dp-tooltip": _ctx.$t('preview'),
          "data-dp-position": "left",
          class: "ms-2"
        }, null, 8, ["page-id", "data-dp-tooltip"]),
        _createVNode(_component_router_link, {
          to: (this.isLibrary)
          ? {name: 'libraries-edit-content-page-wysiwyg', params: {id: this.fullContentPage.id, page_type_code: this.$route.params.page_type_code, lib_code: this.$route.params.lib_code}}
          : {name: this.detailRouteLinkName, params: {id: this.fullContentPage.id}},
          class: _normalizeClass(["btn btn-icon btn-primary ms-2", {'disabled': this.isLinkedPage}]),
          "data-dp-tooltip": _ctx.$t('edit'),
          "data-dp-position": "left"
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }, 8, ["to", "class", "data-dp-tooltip"]),
        _createElementVNode("button", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('delete',this.fullContentPage.id))),
          class: "btn btn-icon btn-danger ms-2",
          "data-dp-tooltip": _ctx.$t('delete'),
          "data-dp-position": "left"
        }, _hoisted_23, 8, _hoisted_21)
      ])
    ])
  ]))
}